import { useLocation } from "react-router-dom";
import Form from "../form/Form";

const CustomRequirement = ({ appConfig = [], loading = false }) => {
    const location = useLocation();


    // Extract contact_info from appConfig array
    const contactInfo = appConfig.find(doc => doc.id === 'contact_info') || {};
    const phone = contactInfo.contactPhone || '+91 98765 43210';
    const email = contactInfo.contactEmail || 'sales@alldoer.com';

    return (
        // Background gradient similar to the image
        <section
            className={`w-full ${location.pathname === "/" ? "bg-gradient-to-br from-[#F9F9F9] via-[#F6F3F2] to-[#F0E6E6] py-20 px-6 md:px-12" : ""} flex items-center justify-center`}
        >
            <div className="max-w-[1440px] mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
                {/* Left Column: Content & Contact Info */}
                <div className="flex flex-col">
                    {/* Headlines */}
                    <h2 className="text-4xl md:text-5xl font-normal text-gray-900 leading-tight">
                        Have a custom
                    </h2>
                    <h2 className="text-4xl md:text-5xl font-normal text-[#737373] leading-tight mb-6">
                        requirement?
                    </h2>

                    {/* Description Paragraph */}
                    <p className="text-lg text-gray-500 leading-relaxed mb-10 max-w-lg">
                        Can't find exactly what you're looking for? That's our specialty.
                        Tell us what you need sourced, and we'll handle the manufacturing
                        and logistics.
                    </p>

                    {/* Contact Details List */}
                    <div className="space-y-6">
                        {/* Contact Item 1: WhatsApp */}
                        <div className="flex items-center gap-4 group cursor-pointer">
                            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105">
                                {/* WhatsApp Icon */}
                                <img
                                    src={"./icons/whatsapp.svg"}
                                    alt="WhatsApp"
                                    className="w-6 h-6 object-contain"
                                />
                            </div>
                            <div className="flex flex-col">
                                <span className="lg:text-2xl text-xl font-normal text-black">
                                    {phone}
                                </span>
                                <span className="text-sm text-gray-500 font-medium">
                                    WhatsApp Us
                                </span>
                            </div>
                        </div>

                        {/* Contact Item 2: Email */}
                        <div className="flex items-center gap-4 group cursor-pointer">
                            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105">
                                {/* Email Icon */}
                                <img
                                    src={"./icons/mail.svg"}
                                    alt="Email"
                                    className="w-6 h-6 object-contain"
                                />
                            </div>
                            <div className="flex flex-col">
                                <span className="lg:text-2xl text-xl font-normal text-black">
                                    {email}
                                </span>
                                <span className="text-sm text-gray-500 font-medium">
                                    Email Sourcing Team
                                </span>
                            </div>
                        </div>

                        {/* Contact Item 3: Call */}
                        <div className="flex items-center gap-4 group cursor-pointer">
                            <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center flex-shrink-0 transition-transform group-hover:scale-105">
                                {/* Phone Icon Placeholder */}
                                <img
                                    src={"./icons/phone.svg"}
                                    alt="Call"
                                    className="w-6 h-6 object-contain"
                                />
                            </div>
                            <div className="flex flex-col">
                                <span className="lg:text-2xl text-xl font-normal text-black">
                                    {phone}
                                </span>
                                <span className="text-sm text-gray-500 font-medium">
                                    Call Support
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Column: The Form */}
                <div className="w-full">
                    <Form />
                </div>
            </div>
        </section>
    );
};

export default CustomRequirement;
